import React, { forwardRef, Component } from 'reactn';
import { Grid, withStyles, Box, Button, List, ListItem, Paper } from '@material-ui/core';
import styles from './index.style';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import FilterListIcon from '@material-ui/icons/FilterList';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import SortIcon from '@material-ui/icons/Sort';
import { Menu } from '..';
import {
  USER_CONTEXT,
  COMMUNICATION_TAB_TYPE,
  COMMUNICATION_SORT_FIELDS,
  LOCATIONS,
  HOUSING_UNITS,
  COMMUNICATION_FILTER,
} from '../../../constants/';
import {
  getCommunicationListAtLocation,
  listUsers,
  qrylocation,
  getStaffList,
  logMsgEvent,
  getCommunicationVisualization,
} from '../../../util/APIUtils';
import DaysFilter from '../../days-filter';
import moment from 'moment';
import { Snippet, MessageViewDialog } from './containers';
import { Filter } from './components';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { Visualization } from '../../communication';
import { isPermitted, PermissionControl } from '../../permission-control/permission-control';
import Hoverable from '../../hoverable';
import { parseTimeToNewZone } from '../../users/learner/transcript/utils';
import { UserIcon } from '../../UserIcon';
import { UnleashService } from '../../../v2/services';
import { COMMUNICATION_TABS } from '../../../v2/services/constants';
import { withUnleash } from '../../../v2/core/unleash';
import Audit from './containers/audit/audit';
import Datatable, { MTableToolbar } from 'material-table';
import { CustomTheme, Loader, Typography, Button as CommonsButton } from '@orijinworks/frontend-commons';
import { CommunicationInfoModal } from '../../../v2/shared/components/communication-info-modal';
import UnleashProvider from '../../../v2/core/unleash/unleashProvider';

class Communications extends Component {
  tableRef = React.createRef();
  communicationColumns = [
    {
      title: 'Sender',
      field: 'senderPersonName',
      cellStyle: {
        width: '25%',
      },
      render: (rowData) => (
        <Hoverable title={rowData.senderPersonName}>
          <Button color="primary" onClick={() => this.openProfile(rowData.senderRoleName, rowData.senderPersonId)}>
            {rowData.senderRoleName && this.getIcon(rowData.senderRoleName)}
            {rowData.senderPersonName}
          </Button>
        </Hoverable>
      ),
    },
    {
      title: 'Recipient',
      field: 'recipientPersonName',
      render: (rowData) => (
        <Hoverable title={rowData.recipientPersonName}>
          <Button color="primary" onClick={() => this.openProfile(rowData.recipientRoleName, rowData.recipientPersonId)}>
            {rowData.recipientRoleName && this.getIcon(rowData.recipientRoleName)}
            {rowData.recipientPersonName}
          </Button>
        </Hoverable>
      ),
    },
    {
      title: 'Location',
      field: 'locationName',
      render: (rowData) => <Hoverable title={rowData.locationName}>{rowData.locationName}</Hoverable>,
    },
    {
      title: 'Date',
      field: 'createdDate',
      render: (rowData) => (
        <Hoverable title={parseTimeToNewZone(rowData.createdDate, this.state.timezoneName)}>
          {parseTimeToNewZone(rowData.createdDate, this.state.timezoneName)}
        </Hoverable>
      ),
    },
    {
      title: 'Status',
      field: 'recordStatus',
      render: (rowData) =>
        !rowData.recordStatus && (
          <Box display="flex">
            <Box className={[this.props.classes.chip]}>
              <Typography className={this.props.classes.chipText} component="p">
                {rowData.recordStatus ? null : 'Hidden'}
              </Typography>
            </Box>
          </Box>
        ),
    },
    {
      title: 'Message',
      field: 'clearBody',
      hidden: true,
    },
    {
      title: 'Actions',
      sorting: false,
      permissionName: 'View_Student_Messages_In_Other_Relationships',
      render: (rowData) => {
        const options = [];
        const View_Messages_Snippets = isPermitted(
          this.global.cbacConfigFlag,
          this.global.permissions,
          'View_Messages_Snippets'
        );
        const View_Threads = isPermitted(this.global.cbacConfigFlag, this.global.permissions, 'View_Threads');
        if (View_Messages_Snippets) {
          options.push({
            title: 'View Snippet',
            onClick: () =>
              this.handleSnippetDialog(true, {
                ...rowData,
                timezoneName: this.state.timezoneName,
              }),
          });
        }
        if (View_Threads) {
          options.push({
            title: 'View Full Thread',
            onClick: () =>
              this.handleDialog('messageViewDialog', true, {
                title: `${rowData.senderPersonName} & ${rowData.recipientPersonName}`,
                data: rowData,
              }),
          });
        }
        return (
          <Hoverable>
            <Menu options={[...options]} />
          </Hoverable>
        );
      },
    },
  ];
  state = {
    isGraphDetailOpen: false,
    timezoneName: 'UTC',
    location: null,
    snippet: {
      isOpen: false,
      title: null,
    },
    messageViewDialog: {
      isOpen: false,
      title: null,
    },
    communicationList: [],
    filters: {
      searchTerm: '',
      location: '',
      people: '',
      status: '',
    },
    filterData: {
      locations: [],
      users: [],
      staff: [],
    },
    pagination: {
      currentPage: 0,
      pageSize: 20,
    },
    sorting: {
      active: null,
    },
    staffProfileDialog: {
      isOpen: false,
      personId: null,
    },
    communicationListLoading: false,
    selectedTab: COMMUNICATION_TABS.messages,
    userDetail: null,
    messagesSummary: [],
  };

  /**
   * @name openProfile
   * @param {string} type
   * @param {number} personId
   * @desc Open's respective profile based upon type passed.
   * @return {void}
   */
  openProfile = (type, personId) => {
    switch (type) {
      case null:
        break;
      case 'Learner':
        this.setGlobal({
          selectedUser: personId,
          openProfileView: true,
          staffProfileID: null,
          staffSelectedLocation: null,
          isStaffProfileOpen: false,
        });
        break;
      default:
        this.setGlobal({
          staffProfileID: personId,
          staffSelectedLocation: this.props.location.active,
          isStaffProfileOpen: false,
          staffRole: type,
          selectedUser: null,
          openProfileView: false,
        });
    }
    this.props.history.push(`/users/${personId}`);
  };

  getStaffs = (locationID) => {
    return new Promise((resolve, reject) => {
      getStaffList(locationID).then(
        (_successLog) => resolve(_successLog.staffList),
        () => resolve([])
      );
    });
  };

  getUsers = (locationID) => {
    return new Promise((resolve, reject) => {
      let postBody = {
        requestorId: 191439,
        requestorLocationId: locationID,
        filterLocationTypeIds: [],
        filterRoleTypeIds: [19, 30],
        filterLocationIds: [],
        filterUserStatus: 'all',
      };
      listUsers(postBody).then(
        (data) => resolve(data.users),
        () => resolve([])
      );
    });
  };

  getIcon = (roleName) => {
    switch (roleName) {
      case 'Attorney':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xlink="http://www.w3.org/1999/xlink"
            svgjs="http://svgjs.com/svgjs"
            version="1.1"
            width="25px"
            height="25px"
            x="0"
            y="0"
            viewBox="0 0 480.004 480.004"
            space="preserve"
            class=""
          >
            <g>
              <g xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                    d="M479.202,292.692l0.072-0.024l-78.808-171.952l19.112-9.512l-7.152-14.32l-18.632,9.28l-2.52-5.496    c-1.842-4.016-6.59-5.779-10.606-3.938c-1.742,0.799-3.139,2.196-3.938,3.938l-2.248,4.912c-13.56-6.298-28.329-9.566-43.28-9.576    h-67.2v-16h16v-16H266.25l5.752-23.016c4.416-17.673-6.33-35.58-24.003-39.997c-17.673-4.416-35.58,6.33-39.997,24.003    c-1.312,5.25-1.312,10.743,0,15.993l5.752,23.016h-13.752v16h16v16h-67.16c-14.966,0.012-29.75,3.288-43.32,9.6l-2.248-4.912    c-1.841-4.016-6.59-5.779-10.606-3.938c-1.742,0.799-3.139,2.196-3.938,3.938l-2.52,5.496l-18.632-9.32l-7.152,14.336    l19.112,9.552L0.73,292.668c-0.486,1.045-0.734,2.184-0.728,3.336c0.035,30.913,25.087,55.965,56,56h80    c30.913-0.035,55.965-25.087,56-56c-0.02-1.149-0.293-2.28-0.8-3.312l-79.024-172.6c11.487-5.332,24-8.092,36.664-8.088h67.16    v292.688l-27.312,27.312h-28.688c-22.08,0.026-39.974,17.92-40,40c0,4.418,3.582,8,8,8h224c4.418,0,8-3.582,8-8    c-0.026-22.08-17.92-39.974-40-40h-28.688l-27.312-27.312V112.004h67.2c12.664-0.004,25.177,2.756,36.664,8.088L288.73,292.668    c-0.486,1.045-0.734,2.184-0.728,3.336c0.035,30.913,25.087,55.965,56,56h80c30.913-0.035,55.965-25.087,56-56    C479.983,294.855,479.71,293.724,479.202,292.692z M136.002,336.004h-80c-19.002-0.021-35.375-13.387-39.2-32h158.4    C171.378,322.617,155.004,335.983,136.002,336.004z M171.538,288.004H20.466l73.488-160.328c1.342,0.36,2.754,0.36,4.096,0    L171.538,288.004z M226.618,22.532c6.23-7.392,17.273-8.333,24.665-2.103c0.759,0.64,1.463,1.344,2.103,2.103    c3.236,4.116,4.379,9.5,3.096,14.576l-6.728,26.896H230.25l-6.728-26.896C222.239,32.032,223.383,26.648,226.618,22.532z     M232.002,96.004v-16h16v16H232.002z M248.002,112.004v288h-16v-288H248.002z M320.002,448.004    c10.168,0.012,19.229,6.418,22.632,16H137.37c3.403-9.582,12.464-15.988,22.632-16H320.002z M268.69,432.004h-57.376l16-16h25.376    L268.69,432.004z M381.938,127.7c1.321,0.465,2.77,0.405,4.048-0.168l73.552,160.472H308.466L381.938,127.7z M424.002,336.004h-80    c-19.002-0.021-35.375-13.387-39.2-32h158.4C459.378,322.617,443.004,335.983,424.002,336.004z"
                    fill={CustomTheme.palette.primary.main}
                    data-original="#000000"
                  />
                </g>
              </g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
            </g>
          </svg>
        );

      case 'Learner':
        return <UserIcon />;

      default:
        return <VerifiedUserIcon />;
    }
  };

  getLocations = (locationID) => {
    return new Promise((resolve, reject) => {
      const pBody = JSON.stringify({
        requestorId: USER_CONTEXT.personId,
        filterLocationId: locationID,
      });
      qrylocation(pBody).then(
        (data) => {
          if (data.locationChildren.length === 0) {
            resolve([]);
          } else {
            resolve(data.locationChildren);
          }
        },
        (_errorLog) => resolve([])
      );
    });
  };
  /**
   * @name getFiltersData
   * @desc A wrapper method used to fetch filters data.
   * @return {void}
   */
  getFiltersData = (locationID) => {
    this.setState({
      isLoading: true,
    });
    let permissionArray = [this.getLocations(locationID)];
    if (isPermitted(this.global.cbacConfigFlag, this.global.permissions, 'View_User_List')) {
      permissionArray = [...permissionArray, this.getUsers(locationID)];
    }
    if (isPermitted(this.global.cbacConfigFlag, this.global.permissions, 'Access_Staff_List')) {
      permissionArray = [...permissionArray, this.getStaffs(locationID)];
    }

    Promise.all(permissionArray).then(
      (dataCollection) => {
        let users = [];
        if (dataCollection[1]) {
          users = [...dataCollection[1]];
        }
        if (dataCollection[2]) {
          users = [...users, ...dataCollection[2]];
        }
        this.setState({
          filterData: {
            ...this.state.filterData,
            users,
            locations: dataCollection[0],
          },
          isLoading: false,
        });
      },
      (_errorLog) => {
        this.setState({
          isLoading: false,
        });
        console.error(_errorLog);
      }
    );
  };
  /**
   * @name handleSnippetDialog
   * @param {boolean} isOpen
   * @param {object} snippetData (optional)
   * @desc Handle's dialog box open state.
   * @return {void}
   */
  handleSnippetDialog = (isOpen, snippetData, isAnnouncement) => {
    this.setState({
      snippet: {
        ...this.state.snippet,
        ...snippetData,
        isOpen,
        isAnnouncement,
      },
    });
  };

  /**
   * @name handleDialog
   * @param {string} parentStateKey
   * @param {boolean} isOpen
   * @desc Handle's all dialog toggle state.
   * @return {void}
   */
  handleDialog = (parentStateKey, isOpen, additionalData) => {
    const parentStateData = this.state[parentStateKey];
    this.setState({
      [parentStateKey]: {
        ...parentStateData,
        ...additionalData,
        isOpen,
      },
    });
  };

  /**
   * @name getLocationTimezone
   * @desc Fetches location timezone from saved locations and props active locations.
   * @return {void}
   */
  getLocationTimezone = () => {
    const { active } = this.state.location;
    let activeLocation = {};

    if (this.state.location.type === 'hu') {
      activeLocation = HOUSING_UNITS.find((location) => location.locationId === active);
    } else {
      activeLocation = LOCATIONS.find((location) => location.locationId === active);
    }
    if (activeLocation) {
      const locationAttribute = (activeLocation.attributes || []).find((attr) => attr.attributeName === 'TimeZone');
      if (locationAttribute) {
        this.setState({
          timezoneName: locationAttribute.attributeValue,
        });
      }
    }
  };

  /**
   * @name initPropToState
   * @desc A wrapper method to initialize properties from prop to state.
   * @return {void}
   */
  initPropToState = () => {
    this.setState(
      {
        location: this.props.location,
        communicationList: [],
      },
      () => {
        this.getLocationTimezone();
      }
    );

    this.getFiltersData(this.props.location.active);
  };

  /**
   * @name getPaginatedData
   * @param {object} query
   * @desc Prepare's pagination data for server side pagination
   * @return {void}
   */
  getPaginatedData = (query) => {
    const pagination = {
      limit: query.pageSize,
      page: query.page,
      orderBy: query.orderBy ? COMMUNICATION_SORT_FIELDS[query.orderBy.field] : 'created_date',
      sortBy: query.orderDirection || 'desc',
    };
    return pagination;
  };

  getDateDateRange = (range) => {
    return {
      startDate: moment(range.startDate).format('YYYY-MM-DD'),
      endDate: moment(range.endDate).format('YYYY-MM-DD'),
    };
  };

  getCommunicationEndpoint = (query) => {
    const locationID = this.state.filters.location !== '' ? this.state.filters.location : this.props.location.active;
    return getCommunicationListAtLocation(
      locationID,
      this.getDateDateRange(this.global.range),
      this.state.filters.searchTerm,
      this.state.filters.people,
      this.getPaginatedData(query),
      this.state.filters.status
    );
  };

  /**
   * @name getCommunicationList
   * @param {number} locationID
   * @desc Fetche's communication list w.r.t locationID
   * @return {void}
   */
  getCommunicationList = (query) => {
    const { sorting } = this.state;
    if (query.orderBy) {
      sorting['active'] = query.orderBy.field;
      sorting[query.orderBy.field] = query.orderDirection;
    } else {
      sorting['active'] = null;
    }
    this.setState({
      communicationListLoading: true,
      sorting,
      showEmptyDataSourceMessage: false,
      isLoading: true,
    });
    return new Promise((resolve, reject) => {
      const locationID = this.state.filters.location !== '' ? this.state.filters.location : this.props.location.active;
      this.getCommunicationEndpoint(query).then(
        (_successLog) => {
          const { totalRecordsCount, messageSummaryDtos } = _successLog;
          let { page } = query;
          if (page < 0) {
            page = 1;
          }
          this.setState({
            pagination: {
              ...query,
              totalCount: totalRecordsCount,
            },
            communicationListLoading: false,
            communicationList: messageSummaryDtos,
            showEmptyDataSourceMessage: true,
            isLoading: false,
          });
          resolve({
            data: messageSummaryDtos,
            totalCount: totalRecordsCount,
            page,
            orderDirection: 'asc',
            orderBy: 'senderPersonName',
          });
        },
        (_errorLog) => {
          resolve({
            data: [],
            page: 0,
            totalCount: 0,
          });
          this.setState({
            isLoading: false,
          });
        }
      );
    });
  };

  /**
   * @name filterUpdateHandler
   * @param {object} filterData
   * @desc Callback fire's when filter is updated.
   * @return {void}
   */
  filterUpdateHandler = (filters) => {
    const { unleashProps } = this.props;
    this.setState(
      {
        filters,
        communicationList: [],
      },
      () => {
        if (this.tableRef.current) {
          if (!unleashProps.isFlagEnabled()) {
            this.visualizationRef.getVisualizationData();
          }
          this.tableRef.current.onChangePage(null, 0);
        }
      }
    );
  };

  /**
   * @name dateChangeHandler
   * @param {object} range
   * @desc Fire's when date change is done.
   * @return {void}
   */
  dateChangeHandler = (range) => {
    const { unleashProps } = this.props;
    this.setState(
      {
        communicationList: [],
      },
      () => {
        if (this.tableRef.current) {
          if (!unleashProps.isFlagEnabled()) {
            this.visualizationRef.getVisualizationData();
          }
          this.tableRef.current.onChangePage(null, 0);
        }
      }
    );
  };

  componentDidMount() {
    this.initPropToState();
  }

  componentDidUpdate() {
    if (this.props.location.active !== this.state.location.active) {
      this.initPropToState();
      this.forceUpdate();
      if (this.tableRef.current) {
        this.tableRef.current.onChangePage(null, 0);
      }
    }
  }

  /**
   * @name exportFile
   * @param {string} fileName
   * @param {string} csvContent
   * @desc Handle's DOM file export functionality.
   * @return {void}
   */
  exportFile = (fileName, csvContent) => {
    var link = document.createElement('a');
    link.setAttribute('href', csvContent);
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link); // Required for FF
    link.click(); // This will download the data file named "${fileName}.csv".
    document.body.removeChild(link);
  };

  /**
   * @name exportCommunicationList
   * @param {array} columns Datatable columns.
   * @param {array} data Datatable data items.
   * @desc Exports communication table with relevant underlying auditing
   * functionality too.
   * @return {void}
   */

  exportCsvFromData = async () => {
    return (
      await this.getCommunicationEndpoint({
        page: 0,
        pageSize: this.state.pagination.totalCount,
      })
    ).messageSummaryDtos;
  };

  exportCommunicationList = async (columns, data, fileName, type, fetchData) => {
    const exemptedColumnsList = ['Actions'];
    this.setState({
      isLoading: true,
    });
    try {
      logMsgEvent({
        messaging_event_type_name: `${type} Exported`,
        details: `${window.navigator.userAgent} \n LocationName: ${this.state.location.locationName}`,
        locationKey: this.state.location.active,
      });
      let csvContent = '';
      const columnString = columns
        .filter((column) => exemptedColumnsList.indexOf(column.title) === -1)
        .map((column) => column.title)
        .join(',');
      // APPENDING COLUMNS
      csvContent += columnString + '\r\n';
      // CONSTRUCTING ROWS
      // BASED UPON COLUMNS KEY
      const data = await fetchData();

      data.forEach((item) => {
        const rowString = columns
          .map((column) => {
            if (column.field) {
              if (item[column.field] || typeof item[column.field] === 'boolean') {
                if (column.field === 'clearBody' || column.field === 'body') {
                  //PARSING HTML INTO PLAIN TEXT FOR EXPORT PURPOSE
                  const domParser = new DOMParser();
                  const document = domParser.parseFromString(item[column.field], 'text/html');
                  return '"' + document.body.innerText + '"';
                } else if (column.field === 'createdDate') {
                  return parseTimeToNewZone(item[column.field], this.state.timezoneName, 'MM/DD/YYYY hh:mm:ss A');
                }
                return '"' + (item[column.field].toString() || '').split('"').join('""') + '"';
              } else if (column.field === 'recipient') {
                return (
                  item.locationName ||
                  item.recipientUserInfo
                    .map((recipient) => {
                      const { firstname, lastname, docId } = recipient;
                      return `${firstname} ${lastname} (${docId || 'N/A'})`;
                    })
                    .join('| ')
                );
              }
              return `N/A`;
            }
          })
          .join(',');
        csvContent += rowString + '\r\n';
      });
      const universalBOM = '\uFEFF';
      let csvData = 'data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + csvContent);
      this.exportFile(fileName, csvData);
      this.setState({
        isLoading: false,
      });
    } catch (e) {
      console.error(e);
      this.setState({
        isLoading: false,
      });
    }
  };

  /**
   * @name getVisualizationData
   * @desc Fetches visualization data w.r.t to type props.
   * @return {void}
   */
  getVisualizationData = () => {
    this.setState({
      isLoading: true,
    });

    getCommunicationVisualization(
      this.props.location.active,
      this.getDateDateRange(this.global.range),
      this.state.filters.searchTerm,
      this.state.filters.people
    ).then(
      (_successLog) => {
        this.setState({
          messagesSummary: _successLog.messagesSummary,
          isGraphDetailOpen: true,
        });
        this.setState({
          isLoading: false,
        });
      },
      (_errorLog) => {
        console.error('Something went wrong', _errorLog);
        this.setState({
          isLoading: false,
        });
      }
    );
  };

  /**
   * @name handleStaffDialog
   * @param {object} updatedState Updated properties
   * @desc Handle's staff dialog state data.
   * @return {void}
   */
  handleStaffDialog = (updatedState) => {
    this.setState({
      staffProfileDialog: {
        ...this.state.staffProfileDialog,
        ...updatedState,
      },
    });
  };

  /**
   * @desc Prepares datatable columns w.r.t to pre-processing required.
   * @return {array}
   */
  get getDatatableColumns() {
    const { sorting } = this.state;
    const columns = this.communicationColumns.map((column) => {
      if (sorting.active === column.field) {
        column['defaultSort'] = sorting[column.field];
      } else {
        column['defaultSort'] = null;
      }
      return column;
    });
    return columns;
  }

  getAllowedFilters = () => {
    let filters = Object.values(COMMUNICATION_FILTER);
    if (this.props.location.type === 'hu') {
      const index = filters.findIndex((item) => item === COMMUNICATION_FILTER.Location);
      filters.splice(index, 1);
    }
    return filters;
  };

  TabSelector = () => {
    const { classes } = this.props;
    const { selectedTab } = this.state;

    return (
      <>
        <Typography variant="h6" className={classes.selectionListHeading}>
          COMMUNICATION TYPE
        </Typography>
        <Box>
          <List className={classes.selectionList}>
            <ListItem
              onClick={(e) => this.onTabChange(e, COMMUNICATION_TABS.messages)}
              button
              className={[
                classes.selectionItem,
                selectedTab == COMMUNICATION_TABS.messages ? classes.selectedItem : '',
              ].join(' ')}
            >
              Messages
            </ListItem>
            <ListItem
              onClick={(e) => this.onTabChange(e, COMMUNICATION_TABS.announcement)}
              button
              className={[
                classes.selectionItem,
                selectedTab == COMMUNICATION_TABS.announcement ? classes.selectedItem : null,
              ].join(' ')}
            >
              Announcements
            </ListItem>
          </List>
        </Box>
      </>
    );
  };

  CustomToolbar = () => {
    const { classes } = this.props;
    const dataManager = this.tableRef.current ? this.tableRef.current.dataManager : null;
    const options = this.tableRef.current ? this.tableRef.current.props.options : null;
    return (
      <Paper elevation={2} className={classes.toolbarPaper}>
        <Grid container>
          <Grid item md={6}>
            <this.TabSelector />
          </Grid>
          <Grid item md={6}>
            <Box width="100%" display="flex" flexDirection="column" alignItems="flex-end">
              <Typography
                variant="h6"
                className={classes.selectionListHeading}
                sx={{
                  width: 525
                }}
              >
                TIME FRAME
              </Typography>
              <Box display="flex" justifyContent="flex-end" width="100%">
                <DaysFilter
                  dateChangeHandler={this.dateChangeHandler}
                  dateRangePickerProps={{
                    left: '-195px',
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Grid container item>
          <Grid md={6}>
            <Box display="flex" justifyContent="flex-start">
              <Filter
                filters={this.state.filters}
                filterUpdateHandler={this.filterUpdateHandler}
                {...this.state.filterData}
                cbacConfigFlag={this.global.cbacConfigFlag}
                permissions={this.global.permissions}
                allowedFilters={this.getAllowedFilters()}
              />
            </Box>
          </Grid>
          <Grid md={6}>
            <Box display="flex" alignItems="center" justifyContent="flex-end">
              <CommonsButton onClick={() => options.exportCsv(dataManager.columns, dataManager.data)} color="secondary">
                <SaveAltIcon />
              </CommonsButton>
              <CommonsButton onClick={this.getVisualizationData} color="secondary">
                View Graph
              </CommonsButton>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    );
  };

  MessagesTable = ({ filteredCommunicationColumn, classes, exportPermission }) => {
    const { unleashProps } = this.props;
    return (
      <Grid container item className={classes.datatable}>
        <UnleashProvider flagName={UnleashService.FLAGS.RESTRUCTURE_COMMUNICATION_TAB}>
          <this.CustomToolbar />
        </UnleashProvider>
        <Datatable
          tableRef={this.tableRef}
          style={{ width: '100%' }}
          columns={filteredCommunicationColumn}
          data={this.getCommunicationList}
          components={{
            Toolbar: (props) => <div>{!unleashProps.isFlagEnabled() && <MTableToolbar {...props} />}</div>,
          }}
          options={{
            pageSize: this.state.pagination.pageSize,
            selection: false,
            showSelectAllCheckbox: true,
            showEmptyDataSourceMessage: this.state.showEmptyDataSourceMessage,
            filtering: false,
            exportButton: exportPermission,
            showTitle: false,
            Sort: SortIcon,
            SortArrow: ArrowDownwardIcon,
            actionsColumnIndex: 0,
            search: false,
            exportFileName: `MessageExport-${moment().format('MM-DD-YYYY')}`,
            exportCsv: (columns, data) =>
              this.exportCommunicationList(
                columns,
                data,
                `MessageExport-${moment().format('MM-DD-YYYY')}`,
                'Messages',
                this.exportCsvFromData
              ),
            selectionProps: (rowData) => ({
              id: `checkbox-${rowData.formId}`,
            }),
          }}
          icons={{
            Search: SearchIcon,
            ResetSearch: CloseIcon,
            FirstPage: FirstPageIcon,
            LastPage: LastPageIcon,
            NextPage: NavigateNextIcon,
            PreviousPage: NavigateBeforeIcon,
            Filter: FilterListIcon,
            SortArrow: ArrowUpwardIcon,
            Export: SaveAltIcon,
            Edit: EditIcon,
            User: UserIcon,
          }}
        />
      </Grid>
    );
  };

  onTabChange = (event, value) => {
    this.setState({ selectedTab: value });
  };

  onGraphToggleHandler = () => {
    this.setState({
      isGraphDetailOpen: !this.state.isGraphDetailOpen,
    });
  };
  render() {
    const { classes, unleashProps } = this.props;
    const exportPermission = isPermitted(this.global.cbacConfigFlag, this.global.permissions, 'Export_Messages');
    const filteredCommunicationColumn = this.getDatatableColumns.filter((item) => {
      return (
        !item.permissionName ||
        isPermitted(this.global.cbacConfigFlag, this.global.permissions, 'View_Student_Messages_In_Other_Relationships')
      );
    });
    return (
      <Grid container item>
        <Loader isLoading={this.state.isLoading} />
        <Snippet
          {...this.state.snippet}
          searchTerm={this.state.filters.searchTerm}
          onClose={() => this.handleSnippetDialog(false)}
        />
        <MessageViewDialog
          {...this.state.messageViewDialog}
          location={this.state.location}
          timezoneName={this.state.timezoneName}
          onClose={() => this.handleDialog('messageViewDialog', false)}
        />
        {!unleashProps.isFlagEnabled() && (
          <>
            <Grid container item>
              <Grid md={6}>
                <Box display="flex" justifyContent="flex-start" padding="20px">
                  <Filter
                    filterUpdateHandler={this.filterUpdateHandler}
                    {...this.state.filterData}
                    cbacConfigFlag={this.global.cbacConfigFlag}
                    permissions={this.global.permissions}
                    allowedFilters={this.getAllowedFilters()}
                  />
                </Box>
              </Grid>
              <Grid item md={6}>
                <Box display="flex" justifyContent="flex-end" marginTop="20px" width="100%">
                  <DaysFilter
                    dateChangeHandler={this.dateChangeHandler}
                    dateRangePickerProps={{
                      left: '-195px',
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
            {this.state.location && (
              <Grid container item>
                <Grid item md={12}>
                  <Box padding="20px">
                    <Visualization
                      {...this.state}
                      type={COMMUNICATION_TAB_TYPE.Location}
                      ref={(ref) => (this.visualizationRef = ref)}
                    />
                  </Box>
                </Grid>
              </Grid>
            )}
          </>
        )}
        <Audit
          exportCommunicationList={this.exportCommunicationList}
          handleSnippetDialog={this.handleSnippetDialog}
          selectedTab={this.state.selectedTab}
          onTabChange={this.onTabChange}
          filteredCommunicationColumn={filteredCommunicationColumn}
          filters={this.state.filters}
          exportPermission={exportPermission}
          location={this.state.location}
          timezoneName={this.state.timezoneName}
          MessagesTable={this.MessagesTable}
          isTopBarShown={unleashProps.isFlagEnabled() ? false : true}
          TabSelector={<this.TabSelector />}
        />
        <CommunicationInfoModal
          messagesSummary={this.state.messagesSummary}
          isOpen={this.state.isGraphDetailOpen}
          range={this.global.range}
          locationName={this.props.location.locationName}
          onClose={this.onGraphToggleHandler}
        />
      </Grid>
    );
  }
}

export default withStyles(styles)(withUnleash(Communications, UnleashService.FLAGS.RESTRUCTURE_COMMUNICATION_TAB));
